const DEFAULT_LOCALE = 'en';

const FLIPDOWN_LABELS = {
    en: {
        Days: 'Days',
        Hours: 'Hours',
        Minutes: 'Minutes',
        Seconds: 'Seconds',
    },
    es: {
        Days: 'Días',
        Hours: 'Horas',
        Minutes: 'Minutos',
        Seconds: 'Segundos',
    },
    'pt-BR': {
        Days: 'Dias',
        Hours: 'Horas',
        Minutes: 'Minutos',
        Seconds: 'Segundos',
    },
};

function formatTargetSeconds(targetUtc) {
    const now = Date.now();

    if (!targetUtc) {
        return Math.floor(now / 1000);
    }

    const parsed = Date.parse(targetUtc);
    if (Number.isNaN(parsed)) {
        return Math.floor(now / 1000);
    }

    return Math.max(Math.floor(parsed / 1000), Math.floor(now / 1000));
}

function translateHeadings(container, locale) {
    if (!container) {
        return;
    }

    const normalizedLocale = FLIPDOWN_LABELS[locale] ? locale : DEFAULT_LOCALE;
    const labels = FLIPDOWN_LABELS[normalizedLocale];

    container.querySelectorAll('.rotor-group-heading').forEach((heading) => {
        const current = heading.getAttribute('data-before');
        if (current && labels[current]) {
            heading.setAttribute('data-before', labels[current]);
        }
    });
}

export function initFlipdownCountdown({
    elementId = 'flipdown',
    targetUtc = null,
    locale = DEFAULT_LOCALE,
    status = null,
    onEnd = null,
    theme = 'light',
} = {}) {
    const container =
        typeof elementId === 'string' ? document.getElementById(elementId) : elementId;

    if (!container || typeof FlipDown === 'undefined') {
        return null;
    }

    const targetSeconds = formatTargetSeconds(targetUtc);

    const countdown = new FlipDown(targetSeconds, container.id)
        .start()
        .ifEnded(() => {
            if (typeof onEnd === 'function') {
                onEnd(status);
            }
        });

    translateHeadings(container, locale);
    if (container) {
        container.classList.remove('flipdown__theme-dark', 'flipdown__theme-light');
        container.classList.add(`flipdown__theme-${theme}`);
    }

    return countdown;
}

export default initFlipdownCountdown;